import React from 'react'
import { connect } from 'react-redux'
import SideBar from '../components/side-bar'

const mapStateToProps = (state) => ({
  ...state.sideBar
})

const mapDispatchToProps = dispatch => ({
  directMessagesSubscribe: payload => dispatch({type: 'SIDE_BAR.DIRECT_MESSAGES_SUBSCRIBE', payload}),
  directMessagesUnsubscribe: payload => dispatch({type: 'SIDE_BAR.DIRECT_MESSAGES_UNSUBSCRIBE', payload})
})

export default connect(mapStateToProps, mapDispatchToProps)(SideBar)
